import { FormControl, InputLabel, MenuItem, Select, SelectChangeEvent } from '@mui/material'
import React from 'react'
import { TagPromotionModel } from '../../../models/tagPromotion.model'
import { useTranslation } from 'react-i18next'

interface Props {
    value: string
    onChange: (event: SelectChangeEvent<any>) => void
    tagPromotionData: TagPromotionModel[]
    disabled:boolean;
}

const SelectedTagPromotionComponent = ({ value, onChange, tagPromotionData,disabled }: Props) => {
     const { t } = useTranslation('global');
    return (
        <FormControl fullWidth size="small" margin='normal' disabled={disabled} >
            <InputLabel id="promotion-label-id">{t("promotion_page.Tag Promotion")}</InputLabel>
            <Select
                labelId="promotion-label-id"
                id="promotion-id"
                label="Tag Promotion"
                value={value}
                onChange={onChange}
                sx={{
                    borderRadius: '8px',
                }}
            >
                {
                    tagPromotionData?.map((item: TagPromotionModel) => (
                        <MenuItem value={item?.id} key={item?.id}>{item?.tagName}</MenuItem>
                    ))
                }
            </Select>
        </FormControl>
    )
}

export default SelectedTagPromotionComponent